import { render, staticRenderFns } from "./NavigationFooter.vue?vue&type=template&id=4814b1cb&scoped=true&"
import script from "./NavigationFooter.vue?vue&type=script&lang=ts&"
export * from "./NavigationFooter.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationFooter.vue?vue&type=style&index=0&id=4814b1cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4814b1cb",
  null
  
)

export default component.exports